import React, { FC } from 'react';

import Container from './container';
import { phone } from './utils';

const KontaktInfo: FC = () => (
    <Container className="contact-container">
        <p className="contact-container__header" role="heading" aria-level={2}>
            Telefonnummer for ulike skadetyper
        </p>
        <ul className="contact-options">
            <li>
                Helse&shy;forsikring og behandlings&shy;garanti:
                <br /> {phone('21 89 75 35')} - Falck Helse
            </li>
            <li>
                Inntekts&shy;forsikring:
                <br /> {phone('800 37 500')} - AXA
            </li>
            <li>
                Råte og skadedyr:
                <br /> {phone('22 28 31 50')} - Norsk Hussopp Forsikring
            </li>
        </ul>
    </Container>
);

export default KontaktInfo;
